export default __webpack_public_path__ + "static/media/Headdress of the Revelations.282bc87a.jpg";